import React, { Component } from 'react';
import { getCompanyName, getUser, getEmptyUser, createUser, updateUserWithoutPwValidation } from '../../Authentication';
import Cleave from 'cleave.js/react';
import CleavePhone from 'cleave.js/dist/addons/cleave-phone.us';
import './userform.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { TagsBySelection } from '../TagsAndChips/TagsBySelection';
import { showNotification } from '../../StatusNotification';

export class UserForm extends Component {
    static displayName = UserForm.name;

    constructor(props) {
        super(props);
        this.state = {
            companyName: null,
            userId: props.userId,
            user: null,
            formType: props.formType,
            isNewUserCompany: props.isNewUserCompany != undefined ? props.isNewUserCompany : false,
            roles: null,
            currentRoles: null
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        let newUser = this.state.user;
        if (name == "phoneNumber") {
            newUser[name] = (value != undefined && value != null && value != "") ? parseInt(value.replace(' ', '').replace(' ', '')) : 0;
        }
        else if (name == "isLockedOut") {
            newUser[name] = e.target.checked ? true : false;
        }
        else {
            newUser[name] = value;
        }

        this.setState({ user: newUser });
    }

    async handleSubmit(e) {
        e.preventDefault();

        let user = this.state.user;
        if (user.company == null || user.company == "" || user.company == undefined) user.company = this.state.companyName;

        if (this.state.formType == 'Create') {
            let result = await createUser(user);

            if (result == "Created") {
                window.location = '/UserManagement';
            }
            else {
                showNotification(result, "error");
            }
        }
        else {
            let result = await updateUserWithoutPwValidation(user);

            if (result == "Updated") {
                window.location = '/UserManagement';
            }
            else {
                showNotification(result, "error");
            }
        }
    }

    render() {
        let firstName;
        let lastName;
        let email;
        let password;
        let access;
        let clientNumber;
        let company = this.state.companyName;
        let phoneNumber;
        let role;
        let lastChanged;
        let isLockedOut;
        let invalidAttempts;
        let relatedClients;

        if (this.state.user != null) {
            let user = this.state.user;
            firstName = user.firstName;
            lastName = user.lastName;
            email = user.email;
            password = user.password;
            access = user.access;
            clientNumber = user.clientNumber;
            company = user.company;
            phoneNumber = user.phoneNumber == 0 ? null : user.phoneNumber;
            role = user.role;
            lastChanged = user.lastChanged;
            isLockedOut = user.isLockedOut;
            invalidAttempts = user.invalidAttempts;
            relatedClients = user.relatedClients;
        }

        let passwordField = this.state.formType == 'Create' ?
            <>
                <label htmlFor='password'>Password: </label>
                <input id='password' name='password' type='password' onChange={this.handleChange} required aria-required="true" minLength="8" maxLength="20" autoComplete="new-password" />
                <div></div>
            </> : "";

        let isLockedOutField = this.state.formType == 'Update' ?
            <>
                <label htmlFor='isLockedOut'>Is Locked Out: </label>
                <div className='checkbox-wrapper'>
                    <input id='isLockedOut' name='isLockedOut' type='checkbox' checked={isLockedOut} onChange={this.handleChange} />
                </div>
                <div></div>
            </> : "";

        let invalidAttemptsField = this.state.formType == 'Update' ?
            <>
                <label htmlFor='invalidAttempts'>Invalid Attempts: </label>
                <input id='invalidAttempts' name='invalidAttempts' type='number' defaultValue={invalidAttempts} onChange={this.handleChange} required aria-required="true" min={0} max={5} step={1} />
                <div></div>
            </> : "";

        let accessField = this.state.isNewUserCompany || this.state.companyName == "FileNFind" ?
            <>
                <label htmlFor='access'>Access: </label>
                <input id='access' name='access' type='number' defaultValue={access} onChange={this.handleChange} required aria-required="true" min={0} step={1} />
                <div></div>
            </> : "";

        let companyField = this.state.isNewUserCompany ?
            <>
                <label htmlFor='company'>Company: </label>
                <input id='company' name='company' type='text' defaultValue={company} onChange={this.handleChange} required aria-required="true" />
                <div></div>
            </> : "";

        let clientNumberField = this.state.companyName == "FileNFind" ?
            <>
                <label htmlFor='clientNumber'>Client Number: </label>
                <input id='clientNumber' name='clientNumber' type='number' defaultValue={clientNumber} onChange={this.handleChange} required aria-required="true" min={0} step={1} />
                <div></div>
            </> : "";

        let roleInfoText = "●Admin: Access to the entier site \n" +
            "●Level4: Division in the company under admin with access to nearly the entier site \n"; 
            //"●Level3: Division in the company under Level4 and above Level2 \n" +
            //"●Level2: Division in the company under Level3 and above Level1 \n" +
            //"●Level1: Lowest level division within the company \n" +
            //"●Client: Contractors with restricted access \n" +
            //"●User: Extremely limited access";
        
        let roleOptions;
        let roleField;
        let roleSelections;

        if (this.state.roles != null) {
            roleOptions = this.state.roles;
            roleSelections = this.state.currentRoles;

            console.log(roleOptions);

            let rolesKeyVal = [];
            if (roleSelections != null) {
                for (var i = 0; i < roleSelections.length; i++) {
                    rolesKeyVal.push({ key: roleSelections[i], value: roleSelections[i] });
                }
            }

            let roleSelectionsKeyVal = [];
            for (var i = 0; i < roleOptions.length; i++) {
                roleSelectionsKeyVal.push({ key: roleOptions[i].name, value: roleOptions[i].name });
            }
            roleField = <>
                <label htmlFor='tagDDL'>Role(s): </label>
                <TagsBySelection
                    tags={rolesKeyVal}
                    tagSelections={roleSelectionsKeyVal}
                    name='role'
                    isRequired={true}
                    allowDuplicates={false}
                    allowDelete={true}
                    showInput={true}
                    tagUpdate={this.handleChange}
                /><div></div>
            </>;
        }

        let relatedClientsField = this.state.companyName == "FileNFind" ?
            <>
                <label htmlFor='relatedClients'>Related Clients: </label>
                <input id='relatedClients' name='relatedClients' type='text' defaultValue={relatedClients} onChange={this.handleChange} />
                <div></div>
            </> : "";

        return (
            <div className='user-form-container'>
                <form onSubmit={this.handleSubmit} className='grid-wrapper'>
                    <div className='tri-grid-offset'>
                        <div className='component-title tri-grid__1-3'>
                            <h1>User Management</h1>
                        </div>

                        <label htmlFor='firstName'>First Name: </label>
                        <input id='firstName' name='firstName' type='text' defaultValue={firstName} onChange={this.handleChange} required aria-required="true" />
                        <div></div>

                        <label htmlFor='lastName'>Last Name: </label>
                        <input id='lastName' name='lastName' type='text' defaultValue={lastName} onChange={this.handleChange} required aria-required="true" />
                        <div></div>

                        <label htmlFor='email'>Email: </label>
                        <input id='email' name='email' type='email' defaultValue={email} onChange={this.handleChange} required aria-required="true" autoComplete="email" />
                        <div></div>

                        <label htmlFor='phoneNumber'>Phone Number: </label>
                        <Cleave id='phoneNumber' name='phoneNumber' value={phoneNumber} options={{ phone: true, phoneRegionCode: 'US' }} pattern="[0-9]{3} [0-9]{3} [0-9]{4}" onChange={this.handleChange} required aria-required="true" autoComplete="tel" />
                        <div></div>

                        {passwordField}

                        {accessField}

                        {clientNumberField}

                        {companyField}

                        {roleField}

                        {isLockedOutField}

                        {invalidAttemptsField}

                        {relatedClientsField}

                        <div className='tri-grid__1-3 form-submit'>
                            <button type='submit' className='form-button'>Save</button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getRoles() {
        const response = await fetch('RoleManagement/GetRoles', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();
        console.log(data);

        return data;
    }

    async getCurrentRole() {
        const response = await fetch('RoleManagement/GetRolesByUserId', {
            method: 'POST',
            body: this.state.userId,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();
        console.log(data);

        return data;
    }

    async getComponentData() {
        const companyName = await getCompanyName();
        const userString = this.state.userId > 0 ? await getUser(this.state.userId, companyName) : await getEmptyUser();
        const user = JSON.parse(userString);
        const roles = await this.getRoles();
        let currentRoles;
        if (this.state.formType != "Create") {
            currentRoles = await this.getCurrentRole();
        }
        else {
            currentRoles = null;
        }
        if (user == null) { // An error ocurred or the id and company do not match
            window.location = 'UserManagement';
        }
        else {
            this.setState({
                companyName: companyName,
                user: user,
                roles: roles,
                currentRoles: currentRoles
            });
        }
    }
}

export default UserForm;